export const GetCurrency = (price: any, code: string, local?: string) => {
  return new Intl.NumberFormat(local ? local : "en-US", {
    style: "currency",
    currency: code,
    maximumSignificantDigits: 10,
    maximumFractionDigits:30
  }).format(price);
};
